// PaymentAcknowledgement.js

import PlanningAndZoningAcknowledgement from './PlanningAndZoningApplication';
import RoadAcknowledgement from './RoadApplication';
import TreeAcknowledgement from './TreeApplication';
import SolicitorAcknowledgement from './SolicitorApplication';
import CharitableSolicitationAcknowledgement from './CharitableSolicitationAcknowledgement';
import UsedCarDealerAcknowledgement from './UsedCarDealer';
import VendingAcknowledgement from './ClerkVending';
import PetLicenseAcknowledgement from './PetLicense';
import ConstructionAcknowledgement from './ConstructionAcknowledgement';
import FoodandBeveragesAcknowledgement from './FoodandBeveragesAcknowledgement';

const PaymentAcknowledgement = ({
  showPaymentAcknowledgement,
  applicationDetails,
  totalAmountPayable,
  totalAmountWithoutTax,
  totalTaxAmount,
  applicationNumber,
  basePath,
  currentPermitDetails
}) => {
  const permitId = currentPermitDetails?.id;
  if (!showPaymentAcknowledgement) return null; // If not showing, return null to render nothing

  // Mapping permit IDs to components
  const applicationAcknowledgementComponents = {
    1: PlanningAndZoningAcknowledgement,
    2: RoadAcknowledgement,
    4: TreeAcknowledgement,
    6: SolicitorAcknowledgement,
    5: CharitableSolicitationAcknowledgement,
    7: UsedCarDealerAcknowledgement,
    8: VendingAcknowledgement,
    9: ConstructionAcknowledgement,
    10: PetLicenseAcknowledgement,
    12: FoodandBeveragesAcknowledgement
  };

  const ApplicationComponent = applicationAcknowledgementComponents[permitId];

  return (
    <ApplicationComponent
      applicationDetails={applicationDetails}
      totalAmountPayable={totalAmountPayable}
      totalAmountWithoutTax={totalAmountWithoutTax}
      totalTaxAmount={totalTaxAmount}
      applicationNumber={applicationNumber}
      basePath={basePath}
    />
  );
};

export default PaymentAcknowledgement;
